import React from 'react';
import './ChatHistoryItem.css';

const ChatHistoryItem = ({ title, date, onClick }) => {
  return (
    <div className="historical-item" onClick={onClick}>
      <div className="historical-title">{title}</div>
      <div className="historical-date">{date}</div>
    </div>
  );
};

export default ChatHistoryItem;
